import { Injectable, signal } from '@angular/core';

export interface LoadingState {
  isLoading: boolean;
  message?: string;
  messageKey?: string;
  progress?: number; // Percentage (0-100)
}

@Injectable({
  providedIn: 'root',
})
export class FullPageLoadingService {
  private readonly loadingState = signal<LoadingState>({ isLoading: false });

  get state() {
    return this.loadingState.asReadonly();
  }

  get currentState(): LoadingState {
    return this.loadingState();
  }

  show(message?: string, messageKey?: string, progress?: number): void {
    this.loadingState.set({ isLoading: true, message, messageKey, progress });
  }

  updateProgress(progress: number): void {
    const currentState = this.loadingState();
    if (currentState.isLoading) {
      this.loadingState.set({ ...currentState, progress });
    }
  }

  updateMessage(message: string): void {
    const currentState = this.loadingState();
    if (currentState.isLoading) {
      this.loadingState.set({ ...currentState, message });
    }
  }

  hide(): void {
    this.loadingState.set({ isLoading: false });
  }
}

